import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalOrdersbrandOrderToken from "@faire/web-api--source/routes/brand-portal/orders/brandOrderToken";
import brandPortalOrdersbrandOrderTokenOrderInvoice from "@faire/web-api--source/routes/brand-portal/orders/brandOrderToken/order-invoice";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

interface IInvoiceDetailsIAProps {
  isAusOrEurBrand: boolean;
  brandOrderToken?: string;
}

export const InvoiceDetailsIA: React.FC<IInvoiceDetailsIAProps> = ({
  isAusOrEurBrand,
  brandOrderToken,
}) => {
  if (isAusOrEurBrand && brandOrderToken) {
    return (
      <Column>
        <Typography>
          <StrictLocalMsg
            defaultMessage="We will provide you with order invoices for any order you receive on Faire. Invoices will be finalized once the order has shipped. You can find an order invoice by going to <OrderLinkFormatting>Orders</OrderLinkFormatting>, navigating to a specific <OrderLinkFormatting>Order details page</OrderLinkFormatting>, and selecting Order invoice."
            description={{
              text: "Description for the instant answer about invoice details",
            }}
            values={{
              OrderLinkFormatting: (chunks: JSX.Element) =>
                OrderLinkFormatting(chunks, brandOrderToken),
              InvoiceLinkFormatting: (chunks: JSX.Element) =>
                invoiceLinkFormatting(chunks, brandOrderToken),
            }}
          />
        </Typography>
      </Column>
    );
  } else {
    return (
      <Column>
        <Typography>
          <StrictLocalMsg
            defaultMessage="You won’t receive order invoices. However, you can reference your payout summary on the <OrderLinkFormatting>Order details page</OrderLinkFormatting> and generate your own invoice based on the information provided. If you choose to create your own invoice, please remember it’s for your internal use only and should not be sent to Faire or any retailer."
            values={{
              OrderLinkFormatting: (chunks: JSX.Element) =>
                OrderLinkFormatting(chunks, brandOrderToken),
            }}
            description={{
              text: "Description for the instant answer about invoice details",
            }}
          />
        </Typography>
      </Column>
    );
  }
};

const OrderLinkFormatting = (chunks: JSX.Element, brandOrderToken?: string) => {
  if (!brandOrderToken) {
    return <Bold>{chunks}</Bold>;
  } else {
    return (
      <Button
        variant="tertiary"
        linkTo={brandPortalOrdersbrandOrderToken(brandOrderToken)}
        target="_blank"
      >
        <Bold>{chunks}</Bold>
      </Button>
    );
  }
};

const invoiceLinkFormatting = (
  chunks: JSX.Element,
  brandOrderToken: string
) => (
  <Button
    variant="tertiary"
    linkTo={brandPortalOrdersbrandOrderTokenOrderInvoice(brandOrderToken)}
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);
